<template>
  <b-form-group
    class="font-weight-semibold mb-0"
    :label="label">
    <b-input-group class="input-group-merge">
      <b-input-group-prepend is-text>
        <feather-icon icon="SearchIcon" />
      </b-input-group-prepend>
      <b-form-input
        v-model="innerValue"
        v-bind="$attrs"
        :placeholder="placeholder" />
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  props: {
    value: {
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
